export const REINVEST_STATUSES = ["APPROVED", "COMPLETED", "CLOSED", "CANCELED"];

export const BannerTypeMap = {
  "IN-PROGRESS": "equidefi.yellow",
  COMPLETED: "equidefi.green",
  CANCELED: "equidefi.red",
};
